import { render, staticRenderFns } from "./block.vue?vue&type=template&id=f73ba2b0"
import script from "./block.vue?vue&type=script&lang=ts"
export * from "./block.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports